import fimg1 from "../images/services/icon-5.webp";
import fimg2 from "../images/services/icon-6.webp";
import fimg3 from "../images/services/icon-7.webp";
import fimg4 from "../images/services/icon-8.webp";
import fimg5 from "../images/services/icon-9.webp";
import fimg6 from "../images/services/icon-10.webp";

const Features = [
  {
    Id: "01",
    fImg: fimg1,
    title: "Mega Stadium Format",
    description:
      "An immersive experience in world-class venues designed to facilitate learning, networking, and collaboration at scale.",
    buttonText: "Explore Venues",
  },
  {
    Id: "02",
    fImg: fimg2,
    title: "Live Investor Funding",
    description:
      "Real-time investment opportunities where businesses can pitch directly to investors and secure funding on the spot.",
    buttonText: "Learn More",
  },
  {
    Id: "03",
    fImg: fimg3,
    title: "AI Cash Flow Tools",
    description:
      "Cutting-edge AI-powered tools that analyze, predict, and optimize business cash flow with unprecedented accuracy.",
    buttonText: "Discover Tools",
  },
  {
    Id: "04",
    fImg: fimg4,
    title: "Business Model Exhibitions",
    description:
      "Showcase of innovative business models that demonstrate exceptional cash flow management principles and practices.",
    buttonText: "View Models",
  },
  {
    Id: "05",
    fImg: fimg5,
    title: "Global Networking",
    description:
      "Connect with entrepreneurs, investors, and industry leaders from over 21 countries to expand your business network.",
    buttonText: "Join Network",
  },
  {
    Id: "06",
    fImg: fimg6,
    title: "Expert Consultations",
    description:
      "One-on-one sessions with financial experts to receive personalized advice tailored to your business needs.",
    buttonText: "Book Session",
  },
];

export default Features;
